import { ReactComponent as Compact } from '../icons/car/Kompaktklasse.svg';
import { ReactComponent as Cabrio } from '../icons/car/Cabrio.svg';
import { ReactComponent as Combi } from '../icons/car/Kombi.svg';
import { ReactComponent as Limo } from '../icons/car/Limousine.svg';
import { ReactComponent as Van } from '../icons/car/Minivan.svg';
import { ReactComponent as Suv } from '../icons/car/SUV.svg';
import { ReactComponent as Bus } from '../icons/car/Bus.svg';
import { ReactComponent as Omnibus } from '../icons/car/Omnibus.svg';
import { ReactComponent as Oepnv } from '../icons/car/oepnv.svg';

export default {
  car: {
    Suv,
    Compact,
    Combi,
    Limo,
    Van,
    Cabrio,
    Bus,
    Omnibus,
    Oepnv,
  },
};
